'use client'
import React, { useMemo } from 'react'
import styles from './styles.module.scss'

interface EmptyGamesSliderPlaceholderProps {
  gamesInSlide: number
  rowCount?: number
}

const EmptyGamesSliderPlaceholder: React.FC<
  EmptyGamesSliderPlaceholderProps
> = ({ gamesInSlide }) => {
  const emptyGamesArray = useMemo(() => {
    let emptyGamesArray: Array<any> = []

    for (let i = 0; i < gamesInSlide; i++) {
      emptyGamesArray.push(<div className={styles.emptyItem} key={i} />)
    }

    return emptyGamesArray
  }, [gamesInSlide])

  return <div className={styles.gridContainer}>{emptyGamesArray}</div>
}

export default React.memo(EmptyGamesSliderPlaceholder)
